import React from 'react';
import { NgapAct } from '../types/ngap';
import ActCard from './ActCard';
import SkeletonGrid from './SkeletonGrid';
import { SimulatorCartItem } from '../features/simulator/types';

interface ResultsGridProps {
  results: NgapAct[];
  cartItems?: SimulatorCartItem[];
  onToggleCartItem?: (act: NgapAct) => void;
  darkMode: boolean;
  loading?: boolean;
  displayCotationType?: 'current' | 'july2025' | 'july2026' | 'sept2026' | 'july2027';
  onHashtagClick?: (hashtag: string) => void;
  defaultRevaloExpanded?: boolean;
}

const ResultsGrid: React.FC<ResultsGridProps> = ({
  results,
  cartItems = [],
  onToggleCartItem,
  darkMode,
  loading = false,
  displayCotationType,
  onHashtagClick,
  defaultRevaloExpanded = false
}) => {
  const cartActIdsSet = React.useMemo(() => new Set(cartItems.map(item => String(item.act.ID))), [cartItems]);

  if (loading) {
    return <SkeletonGrid darkMode={darkMode} count={6} />;
  }

  if (results.length === 0) {
    return (
      <div className={`text-center py-12 rounded-lg ${
        darkMode ? 'bg-appines-petrol' : 'bg-appines-white'
      }`}>
        <div className={`text-6xl mb-4 ${
          darkMode ? 'text-appines-white' : 'text-appines-black'
        }`} id="search-results" aria-live="polite" aria-atomic="true">
          
        </div>
        <h3 className={`text-xl font-semibold mb-2 ${
          darkMode ? 'text-appines-white' : 'text-appines-black'
        }`}>
          Aucun résultat trouvé
        </h3>
        <p className={darkMode ? 'text-appines-white/65' : 'text-appines-petrol/65'}>
          Essayez de modifier vos critères de recherche ou vos filtres
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="grid gap-4">
        {results.map((act, index) => (
          <ActCard
            key={act.ID}
            act={act}
            isInCart={cartActIdsSet.has(String(act.ID))}
            onToggleCartItem={onToggleCartItem}
            darkMode={darkMode}
            animationDelay={index * 50}
            displayCotationType={displayCotationType}
            onHashtagClick={onHashtagClick}
            defaultRevaloExpanded={defaultRevaloExpanded}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(ResultsGrid);
